import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState('casting', ['application']),
        ...mapGetters('casting', ['applicationConfirmed']),
    },
    methods: {
        ...mapActions('casting', ['updateApplication']),
    },
};
